import { ApolloError } from '@apollo/client';
import { createContext } from 'react';

import { CheckoutStep, Product, Ticket } from './helpers';
import { ErrorBag } from '../../common/helpers';
import { PaymentMethodsInfo } from '../../common/usePaymentMethods';
import { PersonalisationInfo } from './usePersonalisationInfo';
import { StateContextValue } from './StateContext';
import { TeamFlags } from '../../common/Teams/helpers';
import useQuantities from './useQuantities';

export interface CheckoutContextValue extends Partial<StateContextValue>, ReturnType<typeof useQuantities> {
  standAloneProducts: Product[];
  personalisation: PersonalisationInfo;
  teamFlags: Record<string, TeamFlags<Ticket>>;
  allowCompanies: boolean;
  requireInvoiceDetails: boolean;
  validators: {
    [step in CheckoutStep]: {
      valid: boolean;
      errors: ErrorBag;
      validating: string[];
      updateCustomErrors: (errors: ErrorBag, prefix: string) => void;
      updateValidating: (validating: string[], prefix: string) => void;
    };
  };
  error?: ApolloError;
  paymentMethods?: PaymentMethodsInfo;
}

const initialContext = {} as CheckoutContextValue;

export default createContext<CheckoutContextValue>(initialContext);
